import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { CompanyListResponseType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getCompanyListing = (payload: CompanyListResponseType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}getCompanyListing`, payload);
      dispatch({
        type: action_types.COMPANY_DETAILS,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.COMPANY_DETAILS,
        data: { loading: false },
      });
    }
  };
};

export const getClientManagerFormList = () => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(`${baseURL}getClientManagerFormList`);
    dispatch({
      type: action_types.CLIENT_MANAGER_FORM_LIST,
      data,
    });
  };
};

export const getCompanyDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getCompanyDetails/${id}`);
      dispatch({
        type: action_types.GET_COMPANY_DETAILS,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_COMPANY_DETAILS,
        data: { loading: false },
      });
    }
  };
};

export const removeCompanyDetailsData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_COMPANY_DETAILS,
      data: { payload: {}, loading: true },
    });
  };
};
